import styled from 'styled-components';

export const SidebarListItemRow = styled.div
.attrs(() => ({
  className: '  black-text ',
}))`

// width:220px;
width:90%;
height:40px;
display:flex;
// border:2px dashed white
// background:red;
border:none;
margin-top:14px;
:hover{
  background: rgba(79, 70, 229, 0.05);
  border-radius: 5px;
}

`;

export const SidebarListItemIconContainer = styled.div
.attrs(() => ({
  className: '',
}))`

width:40px;
height:38px;
// border:"2px dashed blue",
padding-top:8px;
`;


export const SidebarListItem = styled.div
.attrs(() => ({
  className: '  black-text mt-25',
}))`
font-style: normal;
font-weight: 500;
font-size: 13px;
line-height: 21px;
width:150px;
// background:red;
margin-top:auto !important;
margin-bottom:auto !important;
`;



export const Sidebar= styled.div
.attrs(() => ({
  className: 'white',
}))`
color:#ffffff !important;
font-size:16px;
border:none !important;
padding-left:10px;
min-height:1300px;
`;





export const FieldBtn  = styled.button
.attrs(() => ({
  className: 'btn-flat center btn large white-text w-100',
}))`
border-radius: 5px;
background: var(--primary-indigo, #4F46E5) !important;
// width:80% !important;
width:178px !important;
height:46px !important;
color: var(--white, #FFF);
font-size: 13px;
font-family: Plus Jakarta Sans !important;
font-style: normal;
font-weight: 600;
text-transform: capitalize !important;
`;